import * as React from 'react';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ComplexValue } from 'app/types-shared';
import { mapConnectedToCases } from '../../mapping/map-connected-to-cases';
import { BowtieTranslation } from '../../constants';
import { BowtieCase } from '../../types';
import { ConnectedCasesState } from '../../types-store';
import { TooltipSectionElement } from './tooltip-parser';
import { TooltipConnectedHeader } from './tooltip-connected-header';
import { TooltipTableBody } from './tooltip-table-body';

interface TooltipConnectedTableProps {
  caseNumber: number;
  draftData: BowtieCase;
  connectedCases: ConnectedCasesState;
  connectionTypes: ComplexValue<number>[];
  loadConnectedCases: (caseNumber: number, connectionType: number) => void;
  renderField: (caseData: BowtieCase, fieldName: string) => JSX.Element;
  renderLabel: (caseData: BowtieCase, fieldName: string) => string;
  templates: TooltipSectionElement[];
  applicationUrl: string;
  translation: BowtieTranslation;
}

interface TooltipConnectedTableState {
  selectedConnection: ComplexValue<number>;
}

export class TooltipConnectedTable extends React.PureComponent<TooltipConnectedTableProps, TooltipConnectedTableState> {

  constructor(props: TooltipConnectedTableProps) {
    super(props);
    this.state = {
      selectedConnection: props?.connectionTypes[0] ?? undefined
    };
  }

  public componentDidMount() {
    this.loadConnected(this.props?.connectionTypes[0]?.value);
  }

  private selectConnection = (selectedConnection: ComplexValue<number>) => {
    this.setState({
      selectedConnection
    });
    this.loadConnected(selectedConnection.value);
  }

  private loadConnected(connectionType: number) {

    const { caseNumber, connectedCases } = this.props;

    if (isDefinedIncludingZero(connectionType)) {

      const fetching = connectedCases?.fetching?.[caseNumber]?.includes(connectionType);
      const hasData = connectedCases?.connected?.[caseNumber]?.[connectionType];

      if (!fetching && !hasData) {
        this.props.loadConnectedCases(this.props.caseNumber, connectionType);
      }
    }
  }

  public render() {
    const { caseNumber, connectionTypes, draftData, connectedCases,
      renderField, renderLabel, templates, applicationUrl, translation } = this.props;

    if (!connectionTypes || connectionTypes.length === 0 || !templates || templates.length === 0 || !this.state.selectedConnection) {
      return null;
    }

    const fetching = !!this.state.selectedConnection &&
      connectedCases?.fetching?.[caseNumber]?.includes(this.state.selectedConnection.value);

    const selectedConnections = mapConnectedToCases(
      caseNumber, this.state.selectedConnection?.value, connectedCases, draftData
    );

    return <>
      <TooltipConnectedHeader
        connections={connectionTypes}
        selected={this.state.selectedConnection}
        selectConnection={this.selectConnection}
        applicationUrl={applicationUrl}
        translation={translation} />
      {fetching
        ? <p>{translation.fetching_evaluation}</p>
        : selectedConnections.length > 0 && <TooltipTableBody
          selectedConnections={selectedConnections}
          selectedConnectionValue={this.state.selectedConnection.value}
          renderField={renderField}
          renderLabel={renderLabel}
          templates={templates}
          translation={translation} />}
    </>;
  }
}
